// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eventbus from "./lib/jGia/jGia/src/eventbus";
import loadComponents from "./lib/jGia/jGia/src/loadComponents.js";

// ——————————————————————————————————————————— IMPORTS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// Modules //
import JGiaAppModule from "./modules/baseAppModules/jGia";
import swupAppModule from "./modules/baseAppModules/appMod-swup";
import LazyLoaderAppModule from "./modules/baseAppModules/LazyLoader/LazyLoader";
// import { getGlobalScrollLockManager } from "./modules/baseAppModules/ScrollLock/ScrollLock.js";
// import WindowScroll from "./modules/baseAppModules/WindowScroll/WindowScroll";
import { unlockScroll } from "./init/init_pageScrollbar.js";

// Init. fn() //
import { init_viewportState } from "./init/init_viewportState.js";
import init_customCursor from "./init/init_customCursor.js";
import init_pageScrollbar from "./init/init_pageScrollbar.js";
// import load

// Components //
import EmailSubmissionForm from "../site/plugins/component-email-submission-form/js/EmailSubmissionForm.js";
import BarChart from "../site/plugins/component-bar-chart/js/BarChart.js";
import Lightbox from "../site/plugins/component-lightbox/js/Lightbox.js";
import PopUp from "../site/plugins/component-pop-up/js/PopUp.js";
import Nav from "../site/snippets/nav/js/Nav.js";
import MobileNav from "../site/snippets/mobileNav/js/MobileNav.js";
import VideoPlayer from "../site/snippets/video-player/js/VideoPlayer.js";
import ImgCarousel from "../site/plugins/component-img-carousel/js/ImgCarousel.js";
import Collapsible from "../site/plugins/component-collapsible/js/Collapsible.js";
import DonutGrafik from "../site/plugins/component-donut-grafik/js/DonutGrafik.js";
import PartnerList from "../site/plugins/component-partner-list/js/PartnerList.js";
import SlideShow from "../site/plugins/component-slide-show/js/SlideShow.js";
import ProjectsGrid from "../site/plugins/component-projects-grid/js/ProjectsGrid.js";
import IntroSlider from "../site/plugins/component-intro-slider/js/IntroSlider.js";
import Preloader from "../site/plugins/component-preloader/js/Preloader.js";
import HelloWorld from "../site/plugins/component-hello-world/js/HelloWorld";
import DonationForm from "../site/plugins/component-donation-form/js/DonationForm.js";
import BetterplaceIntegration from "../site/plugins/component-betterplace-integration/js/BetterplaceIntegration.js";
// import LogoGrid from "../site/plugins/component-logo-grid/js/LogoGrid.js";
// import NewsletterForm from "../site/plugins/component-newsletter-form/js/NewsletterForm.js";

const globalComponents = {
  Nav: Nav,
  MobileNav: MobileNav,
  PopUp: PopUp,
};

const availableComponents = [
  // Local
  { type: "EmailSubmissionForm", script: EmailSubmissionForm },
  { type: "BarChart", script: BarChart },
  { type: "Lightbox", script: Lightbox },
  { type: "PopUp", script: PopUp },
  { type: "ImgCarousel", script: ImgCarousel },
  { type: "Collapsible", script: Collapsible },
  { type: "DonutGrafik", script: DonutGrafik },
  { type: "PartnerList", script: PartnerList },
  { type: "SlideShow", script: SlideShow },
  { type: "ProjectsGrid", script: ProjectsGrid },
  { type: "IntroSlider", script: IntroSlider },
  { type: "Preloader", script: Preloader },
  { type: "HelloWorld", script: HelloWorld },
  { type: "DonationForm", script: DonationForm },
  { type: "BetterplaceIntegration", script: BetterplaceIntegration },
  { type: "VideoPlayer", script: VideoPlayer },
  // { type: "LogoGrid", script: LogoGrid },
  // { type: "NewsletterForm", script: NewsletterForm },

  // Other
  // ...
];

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import load_newsletterSignUpCaptcha from "./utils/load_newsletterSignUpCaptcha.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import pageTransAnim_slide from "./assets/pageTransAnims/pageTransAnim_slide.js";
import pageTransAnim_open_overlay from "./assets/pageTransAnims/pageTransAnim_open_overlay.js";
import pageTransAnim_close_overlay from "./assets/pageTransAnims/pageTransAnim_close_overlay.js";

import consoleStyles from "./assets/consoleStyles/consoleStyles.js";
const { default: logStyle_def, success: logStyle_succ } = consoleStyles;

// ———————————————————————————————————————————— SETUP ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const doc = document;

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_swup_page_load from "./eventHandlers/swup/eh_swup_page_load";
import eh_swup_contentReplaced from "./eventHandlers/swup/eh_swup_contentReplaced.js";

// Custom event handlers for swup module //
const swupEventHandlers = [
  { id: "page:load", handler: eh_swup_page_load },
  { id: "content:replace", handler: eh_swup_contentReplaced },
  {
    id: "animation:in:end",
    handler: () => {
      // Remove any transform styles on main container after animation in ended
      // to prevent conflict with positioning of modals below screen edge
      const main = doc.getElementById("swup");
      if (main) main.style.transform = "none";
    },
  },
  {
    id: "animation:out:start",
    handler: () => {
      // Unlock global scroll (potentially locked by open modal) on page transition start
      unlockScroll();
    },
  },
];

// Custom eventbus handlers for swup module //
const swupEventbusConfig = {
  callsToAnswer: ["document_click"],
  handlers: [{ id: "document_click", handler: () => console.log("swup: document was clicked") }],
};

// ————————————————————————————————————————— MODULE INIT. ————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

(async () => {
  // Fetch app config. //
  console.log("%cFetching app config.", logStyle_def);
  const appConfigRequest = await fetch("/app/config.json");
  console.log("%cApp config. fetched", logStyle_succ);
  const appConfig = await appConfigRequest.json();
  console.log("%cApp config. parsed", logStyle_succ);
  const giaConfig = appConfig?.gia;
  const swupConfig = appConfig?.swup;
  const lazyLoaderConfig = appConfig?.lazyLoader;
  const globalComponentConfigs = appConfig?.globalComponents;
  const localComponentConfigs = appConfig?.localComponents;
  const windowScrollConfig = appConfig?.windowScroll;

  // Extend module configs. //
  swupConfig.eventbus = swupEventbusConfig;
  swupConfig.eventHandlers = swupEventHandlers;
  swupConfig.useNewJGiaPlugin = true;
  swupConfig.with_jsAnimPlugin = true;
  swupConfig.pageTransAnimations = [pageTransAnim_slide, pageTransAnim_open_overlay, pageTransAnim_close_overlay];

  // Test Swup fragm. rules //
  const testRules = [
    {
      from: "/",
      to: "/test-overlay-page",
      containers: ["#overlayPageWrapper"],
      name: "open-overlay",
    },
    {
      from: "/test-overlay-page",
      to: "/",
      containers: ["#overlayPageWrapper"],
      name: "close-overlay",
    },
  ];
  swupConfig.fragments.rules = testRules;

  // Create & collect module app module instances...
  const jGiaInst = new JGiaAppModule(giaConfig, globalComponentConfigs, { availableComponents });
  const swupModInst = new swupAppModule(swupConfig, giaConfig, { availableComponents }, localComponentConfigs);
  const LazyLoaderInst = new LazyLoaderAppModule(lazyLoaderConfig);
  // const WindowScrollInst = new WindowScroll(windowScrollConfig);
  const appModules = [
    jGiaInst,
    swupModInst,
    LazyLoaderInst,
    // WindowScrollInst
  ];

  // Include custom modules...
  // if (fooConfig) appModules.push(new Foo(fooConfig));

  // Init. app modules...
  try {
    console.log("%cInitialising app modules", logStyle_def);
    appModules.forEach((module) => {
      try {
        module.init();
      } catch (error) {
        console.error(`Module "${module.options.name}" failed to initialise.`);
        throw error;
      }
    });
    console.log("%cApp modules initialised", logStyle_succ);
  } catch (error) {
    console.error(error);
  }

  // Expose swup instance to global scope...
  window.swupInst = swupModInst.swupInstance;
})();

// ————————————————————————————————————————— GLOBAL STATE ————————————————————————————————————————— //
// ——————————————————————————————————————— (local storage ) ——————————————————————————————————————— //

// Feature detection //
const has_pointerEvents = window.matchMedia("(pointer: fine)").matches;
doc.documentElement.setAttribute("data-has-mouse", has_pointerEvents);

// Create/Set global state object //
console.log("%cSetting global state", logStyle_def);
const globalState = { mediaIsEnabled: true, features: { has_pointerEvents } };
localStorage.setItem("globalState", JSON.stringify(globalState));

// ——————————————————————————————————— POST DOM-CONTENT-LOADED ———————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

doc.addEventListener("DOMContentLoaded", () => {
  console.log("%cInit. viewport state...", logStyle_def);
  init_viewportState();
  console.log("%cViewport state initialized", logStyle_succ);

  console.log("%cInit. global components...", logStyle_def);
  loadComponents(globalComponents);
  console.log("%cGlobal components initialized", logStyle_succ);

  console.log("%cInit. custom cursor...", logStyle_def);
  init_customCursor();
  console.log("%cCustom cursor initialized", logStyle_succ);

  console.log("%cInit. page scrollbar...", logStyle_def);
  init_pageScrollbar();
  console.log("%cPage scrollbar initialized", logStyle_succ);

  console.log("%cLoad newsletter sign-up captcha...", logStyle_def);
  load_newsletterSignUpCaptcha();

  console.log("%cApp ready.", logStyle_succ);
});

// ———————————————————————————————————————— GLOBAL EVENTS ————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import ebh_Foo_bar from "./eventbusHandlers/ebh_Foo_bar";

// Event emissions //
window.addEventListener("resize", () => eventbus.emit("window_resize", { windowWidth: window.innerWidth }));
doc.documentElement.addEventListener("mouseleave", () => eventbus.emit("document_mouseLeave"));
doc.documentElement.addEventListener("click" || "touchstart", (e) => eventbus.emit("document_click", { eventData: e }));

// Eventbus handling //
// ...

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
